import { __read } from "tslib";
import { transparentize } from 'polished';
import { MAX_RADIUS, RADIUS_DIFFERENCE } from '../constants';
var solidOpacities = [0.01, 0.01, 0.02, 0.02, 0.03, 0.03, 0.04];
var regularOpacities = [
    [0.01, 1],
    [0.02, 0.95],
    [0.03, 0.9],
    [0.04, 0.85],
    [0.05, 0.8],
    [0.08, 0.75],
    [0.01, 0.7],
];
export var generateCircles = function (_a) {
    var color = _a.color, circleStyle = _a.circleStyle;
    return circleStyle === 'solid'
        ? solidOpacities.map(function (opacity, idx) { return ({
            opacity: opacity,
            color: color,
            radius: MAX_RADIUS - idx * RADIUS_DIFFERENCE,
        }); })
        : regularOpacities.map(function (_a, idx) {
            var _b = __read(_a, 2), fillOpacity = _b[0], colorOpacity = _b[1];
            return ({
                opacity: fillOpacity,
                color: transparentize(colorOpacity, color),
                radius: MAX_RADIUS - idx * RADIUS_DIFFERENCE,
            });
        });
};
